import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from "../../utils/scrollUtils";
import { scrollWithOffsetLarge } from "../../utils/scrollUtils";
import { scrollWithOffsetSmall } from "../../utils/scrollUtils";

import logoDark from "../../assets/images/final-logo-dark.png"
import logoLight from "../../assets/images/final-logo-light.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'


export default function NavbarTwo({navClass,manuClass,navDark}){
    const [scroll, setScroll] = useState(false);
    const [isMenu, setisMenu] = useState(false);

    // Handle external social media links with confirmation
    const handleExternalLink = (url, siteName) => {
        const confirmed = window.confirm(
            `You are about to leave our website and visit ${siteName}. This will open in a new window. Do you want to continue?`
        );
        if (confirmed) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    useEffect(() => {
        //activateMenu() # disable the blue highlighting for the active page in the navbar
        window.addEventListener("scroll", () => {
          setScroll(window.scrollY > 50);
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // const handleClickOutside =()=>{
        //     setSearchBox(false)
        // }
        // document.addEventListener("mousedown", handleClickOutside);
      }, []);

      var mybutton = document.getElementById("back-to-top");
        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if(mybutton!=null){
                if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                    mybutton.style.display = "block";
                } else {
                    mybutton.style.display = "none";
                }
            }
        }
     
        // Toggle menu
        const toggleMenu = () => {
            setisMenu(!isMenu);
            if (document.getElementById("navigation")) {
                const anchorArray = Array.from(document.getElementById("navigation").getElementsByTagName("a"));
                anchorArray.forEach(element => {
                    element.addEventListener('click', (elem) => {
                        const target = elem.target.getAttribute("href")
                        if (target !== "") {
                            if (elem.target.nextElementSibling) {
                                if (elem.target.nextElementSibling.nextElementSibling) {
                                    var submenu = elem.target.nextElementSibling.nextElementSibling;
                                    submenu.classList.toggle('open');
                                }
                            }
                        }
                    })
                });
            }
        };

//Menu Active
        function getClosest(elem, selector) {

            // Element.matches() polyfill
            if (!Element.prototype.matches) {
                Element.prototype.matches =
                    Element.prototype.matchesSelector ||
                    Element.prototype.mozMatchesSelector ||
                    Element.prototype.msMatchesSelector ||
                    Element.prototype.oMatchesSelector ||
                    Element.prototype.webkitMatchesSelector ||
                    function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                            i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) { }
                        return i > -1;
                    };
            }

            // Get the closest matching element
            for (; elem && elem !== document; elem = elem.parentNode) {
                if (elem.matches(selector)) return elem;
            }
            return null;

        };

        function activateMenu() {
            var menuItems = document.getElementsByClassName("sub-menu-item");
            if (menuItems) {

                var matchingMenuItem = null;
                for (var idx = 0; idx < menuItems.length; idx++) {
                    if (menuItems[idx].href === window.location.href) {
                        matchingMenuItem = menuItems[idx];
                    }
                }

                if (matchingMenuItem) {
                    matchingMenuItem.classList.add('active');
                
                
                    var immediateParent = getClosest(matchingMenuItem, 'li');
            
                    if (immediateParent) {
                        immediateParent.classList.add('active');
                    }
                    
                    var parent = getClosest(immediateParent, '.child-menu-item');
                    if(parent){
                        parent.classList.add('active');
                    }

                    var parent = getClosest(parent || immediateParent , '.parent-menu-item');
                
                    if (parent) {
                        parent.classList.add('active');

                        var parentMenuitem = parent.querySelector('.menu-item');
                        if (parentMenuitem) {
                            parentMenuitem.classList.add('active');
                        }

                        var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
                        if (parentOfParent) {
                            parentOfParent.classList.add('active');
                        }
                    } else {
                        var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
                        if (parentOfParent) {
                            parentOfParent.classList.add('active');
                        }
                    }
                }
            }
        }


        // Clickable Menu
        if(document.getElementById("navigation")){
            var elements = document.getElementById("navigation").getElementsByTagName("a");
            for(var i = 0, len = elements.length; i < len; i++) {
                elements[i].onclick = function (elem) {
                    if(elem.target.getAttribute("href") === "#") {
                        var submenu = elem.target.nextElementSibling.nextElementSibling;
                        submenu.classList.toggle('open');
                    }
                }
            }
        }
    return(
        <>
            <header id="topnav" className={`${scroll ? "nav-sticky" :""} ${navClass}`}>
                <div id="custom-container" className="container d-flex align-items-center justify-content-between px-3 px-md-0">
                {navDark === true ?  
                <HashLink smooth className="logo" to="/#page-top">
                    <img src={logoDark} height="60" className="logo-light-mode" alt=""/>
                    <img src={logoLight} height="60" className="logo-dark-mode" alt=""/>
                </HashLink> :
                <HashLink smooth className="logo" to="/#page-top">
                    <span className="logo-light-mode">
                        <img src={logoDark} height="60" className="l-dark" alt=""/>
                        <img src={logoLight} height="60" className="l-light" alt=""/>
                    </span>
                    <img src={logoLight} className="logo-dark-mode" alt=""/>
                </HashLink>
                }
                <div className="menu-extras d-flex align-items-center">
                    <div className="menu-item">
                        <Link to="#" className={`navbar-toggle ${isMenu ? 'open' : ''}`} id="isToggle" onClick={() => toggleMenu()}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </Link>
                    </div>
                </div>

                <div id="navigation" style={{ display: isMenu ? 'block' : 'none' }}>
                    <ul className={manuClass}>
                        <li className="parent-parent-menu-item">
                            <HashLink smooth to="/#page-top">Home</HashLink><span className="menu-arrow"></span>
                        </li>
                        <li className="has-submenu parent-parent-menu-item">
                            <HashLink smooth to="/who-we-are#page-top">Who We Are</HashLink><span className="menu-arrow"></span>
                            <ul className="submenu duomegamenu">
                                <li>
                                    <ul>
                                        <li className="megamenu-head">About Us</li>
                                        <li><HashLink smooth to="/who-we-are" className="sub-menu-item">Mission, Vision, & Values</HashLink></li>
                                        <li><HashLink smooth to="/statement-of-nondiscrimination" className="sub-menu-item">Statement of Non-Discrimination</HashLink></li>
                                        <li><HashLink to="/license-info" className="sub-menu-item">Licensing Information</HashLink></li>
                                    </ul>
                                </li>

                                <li>
                                    <ul>
                                        <li className="megamenu-head">Building Wealth</li>
                                        <li><HashLink smooth to="/budgeting-101" className="sub-menu-item">Budgeting 101</HashLink></li>
                                        <li><HashLink smooth to="/words-of-encouragement" className="sub-menu-item">Words Of Encouragement</HashLink></li>
                                        <li><HashLink smooth to="/financial-calculators" className="sub-menu-item">Financial Calculators</HashLink></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="has-submenu parent-parent-menu-item">
                            <Link to="#">Life Insurance</Link><span className="menu-arrow"></span>
                            <ul className="submenu minimegamenu">
                                <li>
                                    <ul>
                                        <li><HashLink smooth to="/term-life#page-top" className="megamenu-head">Temporary</HashLink></li>
                                        <li><HashLink smooth to="/term-life#term-life" scroll={scrollWithOffsetLarge} className="sub-menu-item">Term Life</HashLink></li>
                                        <li><HashLink smooth to="/term-life#page-top" className="sub-menu-item">Employer Life Isn't Enough</HashLink></li>
                                        <li><HashLink smooth to="/term-life#mortgage-protection" scroll={scrollWithOffsetLarge} className="sub-menu-item">Mortgage Protection</HashLink></li>
                                        <li><HashLink smooth to="/term-life#convertible-term-life" scroll={scrollWithOffsetLarge} className="sub-menu-item">Convertible Term Life</HashLink></li>
                                        <li><HashLink smooth to="/term-life#rop-term-life" scroll={scrollWithOffsetLarge} className="sub-menu-item">Return of Premium (ROP) Term Life</HashLink></li>
                                    </ul>
                                </li>

                                <li>
                                    <ul>
                                        <li><HashLink smooth to="/perm-life#page-top" className="megamenu-head">Permanent</HashLink></li>
                                        <li><HashLink smooth to="/perm-life#page-top" className="sub-menu-item">Whole Life</HashLink></li>
                                        <li><HashLink smooth to="/perm-life#universal-life" scroll={scrollWithOffsetSmall} className="sub-menu-item">Universal Life</HashLink></li>
                                        <li><HashLink smooth to="/perm-life#indexed-universal-life" className="sub-menu-item">Indexed Universal Life</HashLink></li>
                                        <li><HashLink smooth to="/perm-life#guaranteed-universal-life" className="sub-menu-item">Guaranteed Universal Life</HashLink></li>
                                    </ul>
                                </li>

                                <li>
                                    <ul>
                                        <li><HashLink smooth to="/supplemental-insurance#page-top" className="megamenu-head">Supplemental</HashLink></li>
                                        <li><HashLink smooth to="/supplemental-insurance#page-top" className="sub-menu-item">Disability</HashLink></li>
                                        <li><HashLink smooth to="/supplemental-insurance#critical-illness-insurance" scroll={scrollWithOffsetLarge} className="sub-menu-item">Critical Illness</HashLink></li>
                                        <li><HashLink smooth to="/supplemental-insurance#accidental-death-insurance" scroll={scrollWithOffsetLarge} className="sub-menu-item">Accidential Death</HashLink></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="has-submenu parent-parent-menu-item">
                            <HashLink smooth to="/join-us#page-top">Join our Team!</HashLink><span className="menu-arrow"></span>
                            </li>
                        <li className="has-submenu parent-parent-menu-item">
                            <Link to="#">Social Media</Link><span className="menu-arrow"></span>
                            <ul className="submenu">


                                <li>
                                    <ul>
                                        
                                        <li><a href="#" className="sub-menu-item" onClick={(e) => { e.preventDefault(); handleExternalLink('https://www.facebook.com/inclusivefamilyinsurance/', 'Facebook'); }}>Facebook</a></li>
                                        <li><a href="#" className="sub-menu-item" onClick={(e) => { e.preventDefault(); handleExternalLink('https://www.instagram.com/dscottsmith_ifi/', 'Instagram'); }}>Instagram</a></li>
                                        <li><a href="#" className="sub-menu-item" onClick={(e) => { e.preventDefault(); handleExternalLink('https://www.linkedin.com/company/inclusive-family-insurance', 'LinkedIn'); }}>LinkedIn</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>

                        <li>
                            <div className="sub-menu-item" style={{paddingTop: "1.15rem"}}>
                                <HashLink smooth to="/#request-quote" scroll={scrollWithOffset} className="btn btn-primary requestQuoteNavButton btn-quote-custom" style={{padding: "0.35rem 1rem"}}>
                                    Request a Quote <FontAwesomeIcon icon={faArrowRight} />
                                </HashLink>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
        </>
    )
}